/**
 * Endpoints da API
 */
export const ENDPOINTS = {
  // Autenticação
  APP_LOGIN: 'v1/api/app/login',
  USER_LOGIN: 'v1/api/users/login',
  USER_LOGOUT: 'v1/api/users/logout',
  USER_CREATE: 'v1/api/users/create',
  USER_VERIFY_EMAIL: 'v2/api/users/verify-email',
  USER_VERIFY_EMAIL_RESEND: 'v2/api/users/verify-email/resend',
  RESET_PASSWORD: 'v2/api/users/reset-password',
  RESET_PASSWORD_VALIDATE: 'v2/api/users/reset-password/validate',
  UPDATE_PASSWORD: 'v2/api/users/update-password',
  
  // Usuários
  USERS: 'v1/api/users',
  
  // Entities
  ENTITIES: 'v1/api/entities',
  ENTITIES_MY: 'v1/api/entities/my',
  ENTITIES_SCHEDULE: 'v1/api/entities/schedule',
  ENTITIES_SCHEDULES: 'v1/api/entities/schedules',
  ENTITIES_IMAGES: 'v1/api/entities/images',
  ENTITIES_INSURANCES: 'v1/api/entities/insurances',
  ENTITIES_SERVICES: 'v1/api/entities/services',

  // Consultations
  CONSULTATIONS: 'v2/api/consultations',
  CONSULTATIONS_LIST: 'v2/api/consultations/list',
  CONSULTATIONS_MEDICATION: 'v2/api/consultations/medication',

  // Documents
  DOCUMENTS: 'v2/api/documents',

  // Services
  SERVICES: 'v1/api/services',

  // V3 Agenda
  V3_AGENDA: 'v3/api/agenda',
  V3_AGENDA_BLOCK: 'v3/api/agenda/block',
  V3_AGENDA_AVAILABLE_SLOTS: 'v3/api/agenda/available-slots',

  // V3 Medical Record
  V3_MEDICAL_RECORD_OWNERS: 'v3/api/medical-record/owners',
  V3_MEDICAL_RECORD_PETS: 'v3/api/medical-record/pets',
  V3_MEDICAL_RECORD_CONSULTATIONS: 'v3/api/medical-record/consultations',
  V3_MEDICAL_RECORD_MEDICATIONS: 'v3/api/medical-record/consultations',
  V3_MEDICAL_RECORD_TIMELINE: 'v3/api/medical-record/timeline',
  V3_MEDICAL_RECORD_DOCUMENTS: 'v3/api/medical-record/documents',

  // V3 Clinic
  V3_CLINIC: 'v3/api/clinic',
  
  // Push Notifications
  PUSH_REGISTER: 'v1/api/push',
  PUSH_DELETE: 'v1/api/push/delete',
  
  // Adicione outros endpoints conforme necessário
};

/**
 * Configuração da API
 */
export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_BASE_URL,
  API_KEY: process.env.REACT_APP_API_KEY,
  TIMEOUT: 30000,
};
